/* eslint-disable no-nested-ternary */
/* eslint-disable  */
import React, { useEffect } from 'react';
import { Box, TextField, Button, Grid, Card, CardContent, CardHeader, FormControlLabel, Checkbox } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { globalColor } from 'views/ConstantColors';
import { useJobTitle } from 'hooks/api/terminology/job-title/useJobTitle';
import Swal from 'sweetalert2';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const JobTitleSchema = Yup.object({
    title: Yup.string().required('Job Title is required'),
    description: Yup.string().required('Description is required'),
    isActive: Yup.boolean()
});

export const JobTitleForm = ({ initialData, onClear }) => {
    const isEditMode = Boolean(initialData?.id);
    const { createJobTitle, updateJobTitle } = useJobTitle();

    useEffect(() => {
        console.log('Form initialData changed:', initialData);
    }, [initialData]);

    const initialValues = {
        id: initialData?.id || 0,
        title: initialData?.title || '',
        description: initialData?.description || '',
        isActive: initialData?.isActive ?? true,
        createdAt: initialData?.createdAt || new Date().toISOString(),
        lastModifiedAt: initialData?.lastModifiedAt || new Date().toISOString()
    };

    const handleFormSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const formattedData = {
                id: values.id,
                title: values.title,
                description: values.description,
                isActive: values.isActive,
                isDeleted: values.isDeleted,
                createdAt: values.createdAt,
                lastModifiedAt: new Date().toISOString()
            };


            if (isEditMode && values.id && values.id !== 0) {
                await updateJobTitle(values.id, formattedData);
                Swal.fire('Success', 'JobTitle updated successfully!', 'success');
            } else {
                await createJobTitle(formattedData);
                Swal.fire('Success', 'JobTitle added successfully!', 'success');
                resetForm();
            }

            if (onClear) {
                onClear();
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            Swal.fire('Error', error.message || 'There was an error processing your request.', 'error');
        } finally {
            setSubmitting(false);
        }
    };

    const handleReset = (resetForm) => {
        resetForm();
        if (onClear) {
            onClear();
        }
    };

    return (
        <Card elevation={3} sx={{ mb: 4 }}>
            <CardHeader
                title={isEditMode ? 'Edit JobTitle' : 'Add New JobTitle'}
                sx={{
                    backgroundColor: globalColor,
                    color: 'white',
                    '.MuiCardHeader-title': { color: 'white', fontSize: '1.2rem', fontWeight: 'bold' }
                }}
            />
            <CardContent>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={JobTitleSchema}
                        onSubmit={handleFormSubmit}
                        enableReinitialize
                        key={initialData?.id || 'new'}
                    >
                        {({ errors, touched, values, setFieldValue, resetForm, isSubmitting }) => (
                            <Form>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={6}>
                                        <Field
                                            as={TextField}
                                            fullWidth
                                            name="title"
                                            label="JobTitle Name"
                                            error={touched.title && Boolean(errors.title)}
                                            helperText={touched.title && errors.title}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <Field
                                            as={TextField}
                                            fullWidth
                                            name="id"
                                            label="Job  Code"
                                            error={touched.id && Boolean(errors.id)}
                                            helperText={touched.id && errors.id}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Field
                                            as={TextField}
                                            fullWidth
                                            name="description"
                                            label="Description"
                                            multiline
                                            rows={3}
                                            error={touched.description && Boolean(errors.description)}
                                            helperText={touched.description && errors.description}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={values.isActive}
                                                    onChange={(e) => setFieldValue('isActive', e.target.checked)}
                                                    name="isActive"
                                                />
                                            }
                                            label="Active"
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                                            <AnimateButton>
                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    onClick={() => handleReset(resetForm)}
                                                    disabled={isSubmitting}
                                                    sx={{
                                                        borderColor: globalColor,
                                                        color: globalColor,
                                                        '&:hover': {
                                                            borderColor: 'rgb(0, 100, 0)',
                                                            color: 'rgb(0, 100, 0)'
                                                        }
                                                    }}
                                                >
                                                    {isEditMode ? 'Cancel' : 'Reset'}
                                                </Button>
                                            </AnimateButton>
                                            <AnimateButton>
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    disabled={isSubmitting}
                                                    sx={{
                                                        bgcolor: globalColor,
                                                        '&:hover': {
                                                            bgcolor: 'rgb(0, 100, 0)'
                                                        }
                                                    }}
                                                >
                                                    {isSubmitting
                                                        ? isEditMode
                                                            ? 'Updating...'
                                                            : 'Adding...'
                                                        : isEditMode
                                                        ? 'Update Job Title'
                                                        : 'Add Job Title'}
                                                </Button>
                                            </AnimateButton>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Form>
                        )}
                    </Formik>
                </LocalizationProvider>
            </CardContent>
        </Card>
    );
};
